import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteTalhaoCadastro } from '../service';
import {
  DELETE_TALHAO_CADASTRO,
  DELETE_TALHAO_CADASTRO_PENDING,
  DELETE_TALHAO_CADASTRO_SUCCESS,
  DELETE_TALHAO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteTalhaoCadastro(action) {
  yield put({ type: DELETE_TALHAO_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.TALHAO_EXCLUIR);

  try {
    const a = yield call(deleteTalhaoCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_TALHAO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_TALHAO_CADASTRO_FAILURE });

    AlertError('Não foi possível excluir o Talhão. Verifique se o mesmo não possui lançamentos no caderno de campo ou se está vinculado em alguma safra.');
  }
}

export default function* watchDeleteTalhaoCadastro() {
  yield takeLatest(DELETE_TALHAO_CADASTRO, sagaDeleteTalhaoCadastro)
}
